import { createTableApi } from '~/api/utils/create-table-api';

export const attributes = {
  ...createTableApi('/user-attribute-settings')
};
